import { render } from "./index_new.vue?vue&type=template&id=cda3fe74&scoped=true"
import script from "./index_new.vue?vue&type=script&lang=js"
export * from "./index_new.vue?vue&type=script&lang=js"

import "./index_new.vue?vue&type=style&index=0&id=cda3fe74&lang=scss&scoped=scoped"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cda3fe74"]])

export default __exports__